
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns8fa9ca7c6d9e406afc0ca3c44ee2e668en from './en.yaml'
            i18n.addResourceBundle('en', '8fa9ca7c6d9e406afc0ca3c44ee2e668', flattenObject(ns8fa9ca7c6d9e406afc0ca3c44ee2e668en), true, true);
        
        export default '8fa9ca7c6d9e406afc0ca3c44ee2e668';
    